import React from 'react'
import '../assets/css/IconModification.scss'
import ColorSettings from '../components/ColorSettings'
import DrawSettings from '../components/DrawSettings'
import SelectionBorderSettings from '../components/SelectionBorderSettings'
import SelectionObjectSettings from '../components/SelectionObjectSettings'
import SelectionTextSettings from '../components/SelectionTextSettings'
import ZoomSettings from '../components/ZoomSettings'

const SelectionPanel = ({
    canvas,
    activeSelection,
    activeTool,
    drawColor,
    setDrawColor,
    setZoom,
    zoom,
    textConfiguration,
    isMarkToolRelease,
    setTextConfiguration
}) => {
    // console.log('canvas?.getActiveObject()?.type:',canvas?.getActiveObject()?.type)
    return (
        <>
            {/* <p className='subtitle'>ALIGNMENT</p> */}
            {/* <SelectionAlignSettings */}
            {/*    canvas={canvas} */}
            {/*    activeSelection={activeSelection} */}
            {/* /> */}

            <p className='subtitle'>OBJECT</p>
            <SelectionObjectSettings
                canvas={canvas}
                activeSelection={activeSelection}
                isMarkToolRelease={isMarkToolRelease}
            />

            {activeTool === 'select' &&
                // canvas?.getActiveObject()?.type !== 'CustomTextbox' &&
                canvas?.getActiveObject()?.type !== 'image' && (
                    <>
                        <p className='subtitle'>BORDER</p>
                        <SelectionBorderSettings
                            canvas={canvas}
                            activeSelection={activeSelection}
                        />
                    </>
                )}
            {activeTool === 'draw' && (
                <>
                    <DrawSettings canvas={canvas} />
                </>
            )}
            {canvas?.getActiveObject()?.type === 'CustomTextbox' && (
                <>
                    <p className='subtitle'>FONT</p>
                    <SelectionTextSettings
                        canvas={canvas}
                        activeSelection={activeSelection}
                        textConfiguration={textConfiguration}
                        setTextConfiguration={setTextConfiguration}
                    />
                </>
            )}
            {canvas?.getActiveObject()?.type !== 'image' && (
                <>
                    <p className='subtitle'>Color</p>
                    <ColorSettings
                        canvas={canvas}
                        activeSelection={activeSelection}
                        drawColor={drawColor}
                        activeTool={activeTool}
                        setDrawColor={setDrawColor}
                    />
                </>
            )}
            <p className='subtitle'>Zoom</p>
            <ZoomSettings
                canvas={canvas}
                activeSelection={activeSelection}
                setZoom={setZoom}
                zoom={zoom}
            />
        </>
    )
}

export default SelectionPanel
